import { Component, OnInit } from '@angular/core';
import { serviceURLService } from '../service/serviceURL';
import { Router } from '@angular/router';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

@Component({
  selector: 'app-view-notification',
  templateUrl: './view-notification.component.html',
  styleUrls: ['./view-notification.component.css']
})
export class ViewNotificationComponent implements OnInit {
  data: any ={};
  notifications: Array<any> = [];
  notificationDetail: Array<any> = [];
  error: any;
  notificationId: any;
  value: any;
  message: any;
  title: any;
  dateCreated: any;
  loading: any;
  image: any;

  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(private serviceURLService: serviceURLService, private router: Router) { }

  ngOnInit() {
    this.notification();
  }

  notification(){

    this.data = {
      "updatedTime": null,
      
    }

    this.notificationDetail = []
    this.serviceURLService.notification(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
      this.notifications = successData.response.notifications;
      for (let i = 0; i < (successData.response.notifications).length; i++) {
        this.notificationId = successData.response.notifications[i]._id;
        if(window.location.href.substring(window.location.href.lastIndexOf('/') + 1) == successData.response.notifications[i]._id){
          this.message = successData.response.notifications[i].message;
          this.title = successData.response.notifications[i].title;
          this.dateCreated = new Date(successData.response.notifications[i].created);
          this.image = successData.response.notifications[i].fileUrl;
          //console.log(this.dateCreated)          
        }
      }
    }, errorData => {
      console.log("not registered");
    })
  }
  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

}
